import { Button, Col, Form, Input, InputNumber, message, Modal, Popconfirm, Row, Select, Switch } from "antd";
import { Plat } from "../../../model/menudesign/Plat";
import { BiCheck, BiX } from "react-icons/bi";
import Colors from "../../../styles/Colors";
import { PostPlats } from "../../../dao/menudesign/PostPlats";
import { GetPlats } from "../../../dao/menudesign/GetPlats";
import { useEffect, useState } from "react";
import { PostIngredientsPlat } from "../../../dao/menudesign/PostIngredientsPlat";
import { GetIngredients } from "../../../dao/menudesign/GetIngredients";
import Ingredient from "../../../model/menudesign/Ingredient";
import { GetVariacio } from "../../../dao/menudesign/GetVariacio";
import { PostVariantsPlat } from "../../../dao/menudesign/PostVariantsPlat";
import Variacio from "../../../model/menudesign/Variacio";
import { PlatIngredient } from "../../../model/menudesign/PlatIngredient";
import { PlatVariacio } from "../../../model/menudesign/PlatVariacio";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";

interface IngredientModalProps {
    element: Plat;
    visible: boolean;
    page: string;
    editar?: boolean;
    onClose: () => void;
}

const PlatModal: React.FC<IngredientModalProps> = ({element, visible, page, editar, onClose}) => {
    const [form] = Form.useForm();
    const [submitting, setSubmitting] = useState(false);
    const tipus = [{value: 'primer',label: 'Primer plat',},{value: 'segon',label: 'Segon plat',},{value: 'complement',label: 'Complement',},{value: 'postre',label: 'Postre',}]
    const grup = [{value: 'gra', label: 'gra'},{value: 'arros', label: 'arròs'},{value: 'verdura', label: 'verdura'},{value: 'cremes', label: 'cremes'},{value: 'sopes', label: 'sopes'},{value: 'pasta', label: 'pasta'}]
    const cuinat = [{value: 'bullir', label: 'Bullir'},{value: 'vapor', label: 'Vapor'},{value: 'forn', label: 'Forn'},{value: 'fregit', label: 'Fregit'},{value: 'cuinat', label: 'Cuinat'},{value: 'estofat', label: 'Estofat'},{value: 'planxa', label: 'Planxa'},{value: 'altres', label: 'Altres'}]
    const [ingredients, setIngredients] = useState<{ value: number; label: string; }[]>([]);
    const [platsList, setPlatsList] = useState<{ value: number; label: string; }[]>([]);
    const [variants, setVariants] = useState<{ value: number; label: string; }[]>([]);
    const [platingList, setPlatingList] = useState<{ id_plat: number; ingredients: PlatIngredient[]; }[]>([]);

    async function checkListas(){
        const dades = await GetPlats(page) || [];
        const ingredients = await GetIngredients(page);
        const variants = await GetVariacio(page);
        const platList = dades.map((element) => ({
            value: element.id,
            label: element.nom,
        }));
        const ingList = ingredients.map((element: Ingredient) => ({
            value: element.id,
            label: element.nom,
        }))
        const varList = variants.map((element: Variacio) => ({
            value: element.id,
            label: element.nom,
        }))
        const plating_list = dades.map((element) => ({
            id_plat: element.id,
            ingredients: element.ingredients
        }))
        setPlatsList(platList);
        setIngredients(ingList);
        setVariants(varList);
        setPlatingList(plating_list);
    }
    const arraysEqual = (a: number[], b: number[]) => {
        if (a.length !== b.length) return false;
        for (let i = 0; i < a.length; i++) {
        if (a[i] !== b[i]) return false;
        }
        return true;
    };


    const hasSameIngredientsAsExisting = (newIds: number[]): boolean => {
        const sortedNew = [...newIds].sort((x, y) => x - y);

        return platingList.some(p => {
        const existingIds = p.ingredients.map(i => i.id_ingredient);
        const sortedExisting = [...existingIds].sort((x, y) => x - y);
        return arraysEqual(sortedNew, sortedExisting);
        });
    };

    async function handleSubmit() {
        const formData = form.getFieldsValue();
        formData.estat = formData.estat ? 1 : 0;
        if (formData.ingredient_plat) {
            const ingArray = formData.ingredient_plat.map((ingredient: any) => ({
                id_ingredient: ingredient.id_ingredient,
                qInfantil: ingredient.qInfantil,
                qPrimaria: ingredient.qPrimaria,
                qAdult: ingredient.qAdult,
                per100: ingredient.per100,
            }));
            const newIds = ingArray.map((i: any) => i.id_ingredient);

            if (hasSameIngredientsAsExisting(newIds)) {
                Modal.confirm({
                    title: "Aquest plat té una llista d'ingredients igual a un altre plat existent. Vols continuar?",
                    okText: "Sí",
                    cancelText: "No",
                    onOk: async () => {
                        formData.ingredient_plat = JSON.stringify(ingArray);

                        if (formData.id_variacio !== undefined && formData.id_alternativa !== undefined) {
                            const varArray = [{
                                id_variacio: formData.id_variacio,
                                id_alternativa: formData.id_alternativa,
                            }];
                            formData.variacio_plat = JSON.stringify(varArray);
                            delete formData.id_variacio;
                            delete formData.id_alternativa;
                        }
                        console.log("Form Data (confirmant):", formData);
                        await PostPlats(formData,page);
                    },
                    onCancel: () => {
                        message.info("Enviament cancel·lat");
                    },
                    });
                return;
            }
            formData.ingredient_plat = JSON.stringify(ingArray);
        }
        //Variants
        if(formData.id_variacio !== undefined && formData.id_alternativa !== undefined){
            const varArray = [{
                id_variacio: formData.id_variacio,
                id_alternativa: formData.id_alternativa
            }];
            formData.variacio_plat = JSON.stringify(varArray);
            delete formData.id_variacio;
            delete formData.id_alternativa;
        }
        console.log("Form Data:", formData);

        await PostPlats(formData,page);
        await onClose();
    };

    async function handleCancel() {
        await onClose();
    };
    useEffect(() => {
        checkListas();
    }, []);
    return (
        <Modal
        title="Crear/Editar Plat"
            open={visible}
            onCancel={handleCancel}
            footer={[
                <>  
                    <Button title={"Acceptar"} style={{backgroundColor: Colors.colors.color6}}
                            onClick={handleSubmit}><BiCheck/></Button>
                    {" "}
                    <Button title={"Cancelar"} style={{backgroundColor: Colors.colors.color1}}
                            onClick={handleCancel}><BiX/></Button>
                </>
            ]}
            width={1200}
        >
            <Form form={form} initialValues={element}>
                <br/>
                <Row gutter={[16, 16]}>
                    <Col span={24}>
                        <Form.Item label="ID" name="id">
                            <Input type="text" disabled={true}/>
                        </Form.Item>
                        <Form.Item label="Nom" name="nom"
                            rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                            <Input type="text"/>
                        </Form.Item>
                        <Form.Item label="Tipus" name="tipus"
                            rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                            <Select
                                showSearch
                                defaultValue={'primer'}
                                placeholder="Selecciona un tipus de plat"
                                optionFilterProp="label"
                                options={tipus}
                            />
                        </Form.Item>
                        <Form.Item label="Grup" name="grup"
                            rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                            <Select
                                showSearch
                                defaultValue={'verdura'}
                                placeholder="Selecciona un grup de plat"
                                optionFilterProp="label"
                                options={grup}
                            />
                        </Form.Item>
                        <Form.Item label="Cuinat" name="cuinat"
                            rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                            <Select
                                showSearch
                                defaultValue={'forn'}
                                placeholder="Selecciona com s'ha cuinat el plat"
                                optionFilterProp="label"
                                options={cuinat}
                            />
                        </Form.Item>
                        <Form.Item label="Cost" name="cost"
                            rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                            <Input type="number" min={0}/>
                        </Form.Item>
                        <Form.Item label="Estat" name="estat">
                            <Switch checkedChildren="1" unCheckedChildren="0"/>
                        </Form.Item>
                        <Form.Item label="Finalitzat" name="finalitzat">
                            <Switch/>
                        </Form.Item>
                    </Col>
                </Row>
                <br/>
                
                    <Form.List
                        name="ingredient_plat"
                        rules={[{
                            validator: async (_, ingredients) => {
                                if(!ingredients || ingredients.length < 1) return Promise.reject(new Error('Ha d\'haver-hi almenys un ingredient'));
                        },},]}
                    >
                        {(fields, { add, remove }, { errors }) => (
                        <>
                            {fields.map(({ key, name, ...restField }) =>(
                                <Row key={key} gutter={[16, 16]}>
                                    <Col span={5}>
                                    <Form.Item 
                                    {...restField}
                                    label="ID Ingredient" 
                                    name={[name, 'id_ingredient']}
                                    rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                                        <Select
                                            showSearch
                                            optionFilterProp="label"
                                            options={ingredients}
                                        />
                                    </Form.Item>
                                    </Col>
                                    <Col span={4}>
                                    <Form.Item 
                                    {...restField}
                                    label="Quant Inf" 
                                    name={[name, 'qInfantil']}
                                    rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                                        <InputNumber min={0} step={0.01}/>
                                    </Form.Item>
                                    </Col>
                                    <Col span={4}>
                                    <Form.Item  
                                    {...restField}
                                    label="Quant Prim" 
                                    name={[name, 'qPrimaria']}
                                    rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                                        <InputNumber min={0} step={0.01}/>
                                    </Form.Item>
                                    </Col>
                                    <Col span={4}>
                                    <Form.Item  
                                    {...restField}
                                    label="Quant Adult" 
                                    name={[name, 'qAdult']}
                                    rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                                        <InputNumber min={0} step={0.01}/>
                                    </Form.Item>
                                    </Col>
                                    <Col span={5}>
                                    <Form.Item  
                                    {...restField}
                                    label="Percentatge" 
                                    name={[name, 'per100']}
                                    rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                                        <Input prefix="%" type="number" min={0} max={100}/>
                                    </Form.Item>
                                    </Col>
                                    {fields.length > 1 ? (
                                    <MinusCircleOutlined
                                        className="dynamic-delete-button"
                                        onClick={() => remove(name)}
                                    />
                                    ) : null}
                                </Row>
                            ))}
                            <Form.Item>
                                <Button
                                    type="dashed"
                                    onClick={() => add()}
                                    style={{ width: '20%' }}
                                    icon={<PlusOutlined />}
                                >
                                    Añade un ingrediente
                                </Button>
                                <Form.ErrorList errors={errors} />
                            </Form.Item>
                        </>)}
                        
                    </Form.List>
                <br/>
                
                <Row gutter={[16, 16]} >
                    <Col span={24}>
                        <Form.Item label="ID Variant" name="id_variacio"
                            rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                            <Select
                                showSearch
                                optionFilterProp="label"
                                options={variants}
                            />
                        </Form.Item>
                        <Form.Item label="ID Plat alternatiu" name="id_alternativa"
                            rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                            <Select
                                showSearch
                                optionFilterProp="label"
                                options={platsList}
                            />
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Modal>
    )
};
export default PlatModal;